export enum PlayerStreamType {
  Video = 0,
  Audio = 1,
}
